import { api } from "./axios";

export interface BrandingState {
  app_name: string;
  has_logo: boolean;
  logo_ext: string | null;
  updated_at: number;
}

export async function getBranding(): Promise<BrandingState> {
  const r = await api.get("/branding");
  return r.data;
}

export async function setAppName(app_name: string): Promise<BrandingState> {
  const r = await api.put("/branding", { app_name });
  return r.data;
}

export async function uploadLogo(file: File): Promise<BrandingState> {
  const fd = new FormData();
  fd.append("file", file);
  const r = await api.post("/branding/logo", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return r.data;
}

export async function deleteLogo(): Promise<BrandingState> {
  const r = await api.delete("/branding/logo");
  return r.data;
}

// URL para mostrar el logo (incluye cache-busting por updated_at).
// La servimos via el path API real (sin /api/v1 prefix porque axios ya lo agrega
// pero esto es para usar como src de <img>, asi que necesita el prefix completo).
export function logoUrl(updatedAt: number): string {
  return `/api/v1/branding/logo?v=${updatedAt}`;
}
